import React from 'react';

const Icon = ({ name, size = 16, className = '', ...props }) => {
  const iconStyle = {
    width: size,
    height: size,
    ...props.style
  };

  const icons = {
    envelope: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
      </svg>
    ),
    lock: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
      </svg>
    ),
    eye: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
      </svg>
    ),
    eyeSlash: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/>
      </svg>
    ),
    signIn: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M11 7L9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5-5-5zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8v12z"/>
      </svg>
    ),
    exclamationTriangle: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    ),
    exclamationCircle: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
      </svg>
    ),
    checkCircle: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
      </svg>
    ),
    infoCircle: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
      </svg>
    ),
    refresh: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/>
      </svg>
    ),
    bars: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
      </svg>
    ),
    'ellipsis-vertical': (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
      </svg>
    ),
    shield: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.6 14.8,10V11.5C15.4,11.5 16,12.4 16,13V16C16,16.6 15.6,17 15,17H9C8.4,17 8,16.6 8,16V13C8,12.4 8.4,11.5 9,11.5V10C9,8.6 10.6,7 12,7M12,8.2C11.2,8.2 10.2,9.2 10.2,10V11.5H13.8V10C13.8,9.2 12.8,8.2 12,8.2Z"/>
      </svg>
    ),
    pills: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M4.22,11.29L11.29,4.22C13.64,1.88 17.43,1.88 19.78,4.22C22.12,6.56 22.12,10.36 19.78,12.71L12.71,19.78C10.36,22.12 6.56,22.12 4.22,19.78C1.88,17.43 1.88,13.64 4.22,11.29M5.64,12.71C4.59,13.75 4.59,15.45 5.64,16.5C6.68,17.54 8.38,17.54 9.43,16.5L16.5,9.43C17.54,8.38 17.54,6.68 16.5,5.64C15.45,4.59 13.75,4.59 12.71,5.64L5.64,12.71M6.35,7.05L7.05,6.35L9.43,8.73L8.73,9.43L6.35,7.05M15.57,14.27L16.27,13.57L18.65,15.95L17.95,16.65L15.57,14.27M12.71,5.64L11.29,7.05L13.57,9.43L15,8L12.71,5.64M8.73,14.57L7.05,16.27L6.35,15.57L8,13.9L8.73,14.57Z"/>
      </svg>
    ),
    syringe: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M6,3H8V5H10.59L12,3.59L13.41,5H16V7H14.41L16.41,9H18V11H16.59L20.91,15.32C21.3,15.71 21.3,16.34 20.91,16.73L16.73,20.91C16.34,21.3 15.71,21.3 15.32,20.91L11,16.59V18H9V16H7V13.41L5,11.41V10H3V8H5V5.41L3.59,4L5,2.59L6,3.59V3M7,7V8.59L14.59,16.17L16.17,14.59L8.59,7H7Z"/>
      </svg>
    ),
    'user-md': (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M12,2A2,2 0 0,1 14,4C14,4.74 13.6,5.39 13,5.73V7H14A7,7 0 0,1 21,14H22A1,1 0 0,1 23,15V18A1,1 0 0,1 22,19H21V20A2,2 0 0,1 19,22H5A2,2 0 0,1 3,20V19H2A1,1 0 0,1 1,18V15A1,1 0 0,1 2,14H3A7,7 0 0,1 10,7H11V5.73C10.4,5.39 10,4.74 10,4A2,2 0 0,1 12,2M7.5,13A2.5,2.5 0 0,0 5,15.5V16.5H7V15.5A2.5,2.5 0 0,0 7.5,13M9,16.5V15.5A2.5,2.5 0 0,0 11.5,13A2.5,2.5 0 0,0 14,15.5V16.5H9M16.5,13A2.5,2.5 0 0,0 14,15.5V16.5H19V15.5A2.5,2.5 0 0,0 16.5,13Z"/>
      </svg>
    ),
    stethoscope: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M19,8C19.56,8 20,8.44 20,9A2,2 0 0,1 18,11H16V9A4,4 0 0,0 12,5A4,4 0 0,0 8,9V11H6A2,2 0 0,1 4,9C4,8.44 4.44,8 5,8H6V9A2,2 0 0,0 8,7A2,2 0 0,0 10,9V8H14V9A2,2 0 0,0 16,7A2,2 0 0,0 18,9V8H19M12,2A2,2 0 0,1 14,4A2,2 0 0,1 12,6A2,2 0 0,1 10,4A2,2 0 0,1 12,2M15,13H9V15H15V13M13,16H11V18H13V16Z"/>
      </svg>
    ),
    desktop: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M21,2H3A2,2 0 0,0 1,4V16A2,2 0 0,0 3,18H10V20H8V22H16V20H14V18H21A2,2 0 0,0 23,16V4A2,2 0 0,0 21,2M21,16H3V4H21V16Z"/>
      </svg>
    ),
    heart: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z"/>
      </svg>
    ),
      question: (
        <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
          <path d="M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z"/>
        </svg>
      ),
      'chevron-left': (
        <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
          <path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z"/>
        </svg>
      ),
      'chevron-right': (
        <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
          <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"/>
        </svg>
      ),
      tags: (
        <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
          <path d="M5.5,7A1.5,1.5 0 0,1 4,5.5A1.5,1.5 0 0,1 5.5,4A1.5,1.5 0 0,1 7,5.5A1.5,1.5 0 0,1 5.5,7M21.41,11.58L12.41,2.58C12.05,2.22 11.55,2 11,2H4C2.89,2 2,2.89 2,4V11C2,11.55 2.22,12.05 2.59,12.41L11.58,21.41C11.95,21.77 12.45,22 13,22C13.55,22 14.05,21.77 14.41,21.41L21.41,14.41C21.77,14.05 22,13.55 22,13C22,12.45 21.77,11.95 21.41,11.58M5.5,5A0.5,0.5 0 0,0 5,5.5A0.5,0.5 0 0,0 5.5,6A0.5,0.5 0 0,0 6,5.5A0.5,0.5 0 0,0 5.5,5Z"/>
        </svg>
      ),
      history: (
        <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
          <path d="M13.5,8H12V13L16.28,15.54L17,14.33L13.5,12.25V8M13,3A9,9 0 0,0 4,12H1L4.96,16.03L9,12H6A7,7 0 0,1 13,5A7,7 0 0,1 20,12A7,7 0 0,1 13,19C11.07,19 9.32,18.21 8.06,16.94L6.64,18.36C8.27,20 10.5,21 13,21A9,9 0 0,0 22,12A9,9 0 0,0 13,3"/>
        </svg>
      ),
    home: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
      </svg>
    ),
    users: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.54 8H16c-.8 0-1.54.37-2.01.99L12 11l-1.99-2.01A2.5 2.5 0 0 0 8 8H5.46c-.8 0-1.54.37-2.01.99L1 14.37V16h2.5v6h2v-6h2v6h2v-6h2v6h2z"/>
      </svg>
    ),
    chartBar: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z"/>
      </svg>
    ),
    cog: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"/>
      </svg>
    ),
    bell: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
      </svg>
    ),
    user: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
      </svg>
    ),
    signOut: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
      </svg>
    ),
    plus: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
      </svg>
    ),
    download: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
      </svg>
    ),
    edit: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
      </svg>
    ),
    trash: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
      </svg>
    ),
    chevronLeft: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
      </svg>
    ),
    chevronRight: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
      </svg>
    ),
    search: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
      </svg>
    ),
    filter: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"/>
      </svg>
    ),
    times: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    ),
    phone: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    calendar: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
      </svg>
    ),
    pause: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
      </svg>
    ),
    play: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M8 5v14l11-7z"/>
      </svg>
    ),
    warehouse: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M12 3L2 12h3v8h14v-8h3L12 3zm0 2.84L18.16 11H16v8H8v-8H5.84L12 5.84z"/>
      </svg>
    ),
    'shopping-cart': (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
      </svg>
    ),
    building: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
      </svg>
    ),
    truck: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
      </svg>
    ),
    'chart-bar': (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z"/>
      </svg>
    ),
    'clipboard-list': (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7zm8 0h2v2h-2zm0 3h2v2h-2zm-8-6h2v2H7zm3 0h2v2h-2zm3 0h2v2h-2z"/>
      </svg>
    ),
    database: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M12 3C7.58 3 4 4.79 4 7s3.58 4 8 4 8-1.79 8-4-3.58-4-8-4zM4 9v3c0 2.21 3.58 4 8 4s8-1.79 8-4V9c0 2.21-3.58 4-8 4s-8-1.79-8-4zm0 5v3c0 2.21 3.58 4 8 4s8-1.79 8-4v-3c0 2.21-3.58 4-8 4s-8-1.79-8-4z"/>
      </svg>
    ),
    'exchange-alt': (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"/>
      </svg>
    ),
    'arrow-up': (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
      </svg>
    ),
    'arrow-down': (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
      </svg>
    ),
    'chevron-up': (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" style={iconStyle} className={className}>
        <polyline points="18 15 12 9 6 15"></polyline>
      </svg>
    ),
    'chevron-down': (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={iconStyle} className={className}>
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    ),
    check: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M9 16.2l-3.5-3.5L4 14.2 9 19l12-12-1.5-1.5z"/>
      </svg>
    ),
    info: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M11 9h2V7h-2v2zm0 8h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
      </svg>
    ),
    list: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M4 10.5A1.5 1.5 0 1 0 4 7.5a1.5 1.5 0 0 0 0 3zm0 6A1.5 1.5 0 1 0 4 13.5a1.5 1.5 0 0 0 0 3zM7 9h13V7H7v2zm0 8h13v-2H7v2z"/>
      </svg>
    ),
    inbox: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4a3 3 0 0 1-6 0H5V5h14v10z"/>
      </svg>
    ),
    fileExcel: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm1 7V3.5L19.5 9H15zM8 12h2l1 1.7L12 12h2l-2 3 2 3h-2l-1-1.7L10 18H8l2-3-2-3z"/>
      </svg>
    ),
    cloudUpload: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M19.35 10.04A7 7 0 0 0 5.69 8.6 5 5 0 0 0 6 18h5v-4H8l4-4 4 4h-3v4h5a4 4 0 0 0 1.35-7.96z"/>
      </svg>
    ),
    arrowRight: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"/>
      </svg>
    ),
    chevronDoubleLeft: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M11.41 7.41L10 6l-6 6 6 6 1.41-1.41L6.83 12l4.58-4.59zm8 0L18 6l-6 6 6 6 1.41-1.41L14.83 12l4.58-4.59z"/>
      </svg>
    ),
    chevronDoubleRight: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M12.59 16.59L14 18l6-6-6-6-1.41 1.41L17.17 12l-4.58 4.59zm-8 0L6 18l6-6-6-6-1.41 1.41L9.17 12l-4.58 4.59z"/>
      </svg>
    ),
    chevronDown: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"/>
      </svg>
    ),
    alertTriangle: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    ),
    alertCircle: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 6h2v6h-2V8zm0 8h2v2h-2v-2z"/>
      </svg>
    ),
    settings: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M19.14 12.94c.04-.31.06-.63.06-.94s-.02-.63-.06-.94l2.03-1.58a.5.5 0 0 0 .12-.64l-1.92-3.32a.5.5 0 0 0-.6-.22l-2.39.96a7.3 7.3 0 0 0-1.63-.94l-.36-2.54a.5.5 0 0 0-.49-.42h-3.84a.5.5 0 0 0-.49.42l-.36 2.54a7.3 7.3 0 0 0-1.63.94l-2.39-.96a.5.5 0 0 0-.6.22L2.71 8.84a.5.5 0 0 0 .12.64l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94l-2.03 1.58a.5.5 0 0 0-.12.64l1.92 3.32c.13.22.39.31.6.22l2.39-.96c.5.38 1.04.69 1.63.94l.36 2.54a.5.5 0 0 0 .49.42h3.84a.5.5 0 0 0 .49-.42l.36-2.54c.59-.25 1.13-.56 1.63-.94l2.39.96c.22.09.47 0 .6-.22l1.92-3.32a.5.5 0 0 0-.12-.64l-2.03-1.58zM12 15.6A3.6 3.6 0 1 1 12 8.4a3.6 3.6 0 0 1 0 7.2z"/>
      </svg>
    ),
    userPlus: (
      <svg viewBox="0 0 24 24" fill="currentColor" style={iconStyle} className={className}>
        <path d="M15 12c2.21 0 4-1.79 4-4S17.21 4 15 4s-4 1.79-4 4 1.79 4 4 4zm-9 8v-1c0-2.67 5.33-4 8-4 .63 0 1.33.08 2.05.24A5.97 5.97 0 0 0 14 20H6zm13-5v-3h-3v-2h3V7h2v3h3v2h-3v3h-2z"/>
      </svg>
    )
  };

  return icons[name] || null;
};

export default Icon;
